import { render, staticRenderFns } from "./reportsCA.vue?vue&type=template&id=1f953df2&scoped=true"
import script from "./reportsCA.vue?vue&type=script&lang=js"
export * from "./reportsCA.vue?vue&type=script&lang=js"
import style0 from "./reportsCA.vue?vue&type=style&index=0&id=1f953df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f953df2",
  null
  
)

export default component.exports